"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = require("react");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SkeletonBase = _interopRequireDefault(require("./SkeletonBase"));

var _baseValues = require("../constants/baseValues");

var _getSize = require("../operators/getSize");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: ", ";\n  height: ", ";\n  min-width: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SkeletonBox = (0, _styledComponents.default)(_SkeletonBase.default).withConfig({
  displayName: "SkeletonBox",
  componentId: "sc-1i9i7dv-0"
})(_templateObject(), function (_ref) {
  var width = _ref.width;
  return (0, _getSize.getSize)(width);
}, function (_ref2) {
  var height = _ref2.height;
  return (0, _getSize.getSize)(height);
}, function (_ref3) {
  var width = _ref3.width;
  return (0, _getSize.getSize)(width);
});
SkeletonBox.defaultProps = {
  height: _baseValues.BOX_BASE_HEIGHT,
  width: _baseValues.BOX_BASE_WIDTH
};
SkeletonBox.propTypes = {
  height: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  width: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
};
var _default = SkeletonBox;
exports.default = _default;
module.exports = exports.default;